import React from "react";
import { colors } from "@rosetta/react-common-ui";

var LoudAudioWaveIcon = function LoudAudioWaveIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === undefined ? 142 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 43 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? colors.error : _ref$color;
  return React.createElement(
    "svg",
    { width: width, height: height, viewBox: "0 0 " + width + " " + height, fill: "none", "data-qa": "LoudAudioWaveIcon" },
    React.createElement("rect", { y: 7.16675, width: 6, height: 28.6667, rx: 3, fill: color }),
    React.createElement("rect", { x: 9.03223, y: 4.77783, width: 6, height: 33.4444, rx: 3, fill: color }),
    React.createElement("rect", { x: 18.0645, y: 10.75, width: 6, height: 21.5, rx: 3, fill: color }),
    React.createElement("rect", { x: 27.0972, y: 4.77783, width: 6, height: 33.4444, rx: 3, fill: color }),
    React.createElement("rect", { x: 36.1289, width: 6, height: 43, rx: 3, fill: color }),
    React.createElement("rect", { x: 45.1616, y: 7.16675, width: 6, height: 28.6667, rx: 3, fill: color }),
    React.createElement("rect", { x: 54.1934, y: 5.375, width: 6, height: 32.25, rx: 3, fill: color }),
    React.createElement("rect", { x: 63.2261, y: 10.75, width: 6, height: 21.5, rx: 3, fill: color }),
    React.createElement("rect", { x: 72.2578, y: 4.77783, width: 6, height: 33.4444, rx: 3, fill: color }),
    React.createElement("rect", { x: 81.2905, width: 6, height: 43, rx: 3, fill: color }),
    React.createElement("rect", { x: 90.3223, y: 7.16675, width: 6, height: 28.6667, rx: 3, fill: color }),
    React.createElement("rect", { x: 99.355, y: 4.77783, width: 6, height: 33.4444, rx: 3, fill: color }),
    React.createElement("rect", { x: 108.387, y: 10.75, width: 6, height: 21.5, rx: 3, fill: color }),
    React.createElement("rect", { x: 117.419, y: 7.16675, width: 6, height: 28.6667, rx: 3, fill: color }),
    React.createElement("rect", { x: 126.452, y: 4.77783, width: 6, height: 33.4444, rx: 3, fill: color }),
    React.createElement("rect", { x: 135.484, y: 10.75, width: 6, height: 21.5, rx: 3, fill: color })
  );
};

export default LoudAudioWaveIcon;